module.exports = __webpack_public_path__ + "fonts/icomoon.8d3ced86.ttf";